import React, { useState, useCallback, useMemo } from 'react';

import { format } from 'date-fns';
import * as Yup from 'yup';

import { includes, isEmpty } from 'lodash';
import { t } from '~/helpers';
import { Report, ListTransfer } from '~/components';
import Input from '~/components/Form/Input'
import { DateTime, Autocomplete, RadioGroup } from '~/components/Form';

export default function SaldoCombustivelNosPostosDataPostos() {
  const [open, setOpen] = useState(true);
  const [posts, setPosts] = useState([]);
  const [product, setProduct] = useState({});

  const data = useMemo(() => format(new Date(), 'dd/MM/yyyy'), []);

  const handleCloseReport = useCallback(() => {
    setOpen(false);
  }, []);

  const handleValidate = useCallback(async (formData) => {
    try {
      const schema = Yup.object().shape({
        data: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        produto: Yup.string().nullable().required(t('s.geral.validacao.campoobrigatorio')),
        turno: Yup.number().typeError(t('s.geral.validacao.campoobrigatorio')).min(1, 'O Turno deve ser no mínimo 1').max(10, 'o turno deve ser no máximo 10')
          .required(t('s.geral.validacao.campoobrigatorio'))
      });

      await schema.validate(formData, { abortEarly: false });

      if (isEmpty(posts)) {
        throw 'Selecione ao menos um posto para continuar';
      }
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      } else {
        throw err;
      }
    }
  }, [posts]);

  const onSerializeData = useCallback((formData) => ({
    ...formData,
    data: `${formData.data} 00:00:00`,
    produtostr: product.prod_descricao,
    ...posts.reduce(
      (a, b, key) => Object.assign(a, { [`posto${key}`]: b.poco_codigo }), {})
  }), [posts, product]);

  return (
    <Report
      open={open}
      onClose={handleCloseReport}
      serialize={onSerializeData}
      validate={handleValidate}
      title="Saldo Combustível nos Postos na Data - Postos"
      relatorio="SALDOCOMBUSTIVELPOSTODATAPOSTOS"
      initials={{ data, formato: 'pdf', turno: '1' }}
    >
      <DateTime label="Data Inicial" name="data" />

      <Autocomplete
        name="produto"
        label="prod_display"
        title="Produto"
        url="produtos"
        unique="prod_codigo"
        getValue={(value) => setProduct(value)}
      />

      <Input name="turno" label="turno" type="number" defaultValue={1} inputProps={{ min: 1, max: 10 }} />



      <ListTransfer
        leftTitle="Postos Disponíveis"
        rightTitle="Postos Selecionados"
        url="postosporusuario"
        transfer="complete"
        cells={[{ id: 'poco_codigo', label: 'poco_desc_abrev' }]}
        onCallback={(value) => {
          setPosts(value)
        }}
        maxWidth={22}
        maxHeight={200}
        label="poco_desc_abrev"
        unique="poco_codigo"
      />



      <RadioGroup
        row
        name="tipo"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
        defaultValue="pdf"
      />
    </Report>
  )
}
